import PropTypes from "prop-types";
import { childrenPropType, classNamePropType, titlePropType } from "../../common";

/**
 * PropTypes for Accordion component
 *
 * @property {Array<{title: string, content: React.ReactNode, disabled?: boolean}>} [items] - Array of accordion items
 * @property {string} [className] - Additional CSS classes
 * @property {boolean} [allowMultiple] - Allow multiple panels to be open simultaneously
 * @property {Array<number>} [defaultOpen] - Array of initially open panel indices
 */
export const accordionPropTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: titlePropType.isRequired,
      content: childrenPropType.isRequired,
      disabled: PropTypes.bool,
    })
  ),
  className: classNamePropType,
  allowMultiple: PropTypes.bool,
  defaultOpen: PropTypes.arrayOf(PropTypes.number),
};
